/**
 * @file
 * Behaviors for the Forms.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Header behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.forms = {
    attach: function() {
      $(
        '.form-type-textfield, .form-type-tel, .form-type-email, .form-type-textarea'
      )
        .children('input')
        .focus(function() {
          $(this)
            .siblings('label')
            .css('display', 'inline-block')
            .removeClass('visually-hidden');
        })
        .focusout(function() {
          $(this)
            .siblings('label')
            .css('display', 'none')
            .addClass('visually-hidden');
        });
    }
  };
})(Drupal, jQuery);
